/**
 * common pages
 */
import { pages as commonPage } from '@huaying/hy-vue-common'

import AdminRole from './utils/auth'

const Login = () => import('@/components/Login.vue')
const Layout = () => import('@/components/Layout.vue')

const SubLayout = () => import('@/components/SubLayout.vue')

/** Common */
const UserList = () => import('@/pages/Common/User/List.vue')
const UserAnalysis = () => import('@/pages/Common/User/Analysis.vue')
const UserDetail = () => import('@/pages/Common/User/Detail.vue')
const UserAddProduct = () => import('@/pages/Common/User/AddProduct.vue')
// const BusinessCaseList = () => import('@/pages/Common/Website/CaseList.vue')
// const BusinessCaseEdit = () => import('@/pages/Common/Website/CaseEdit.vue')
const CustomerIpRecord = () => import('@/pages/Common/User/IpRecord.vue')
const CommonAnalysis = () => import('@/pages/Common/Analysis.vue')
const CommonNotice = () => import('@/pages/Common/Notice/List.vue')

/** Common End */

/** FwBusiness */
/** Customer  */
const CustomerBusinessList = () => import('@/pages/FwBusiness/Customer/BusinessList.vue')
const ServiceProvisionList = () => import('@/pages/FwBusiness/Customer/ServiceProvision.vue')
const CustomerList = () => import('@/pages/FwBusiness/Customer/CustomerList.vue')
const CustomerInformation = () => import('@/pages/FwBusiness/Customer/CustomerInformation.vue')
const CustomerDetail = () => import('@/pages/FwBusiness/Customer/CustomerDetail.vue')
const ContactDetail = () => import('@/pages/FwBusiness/Customer/ContactDetail.vue')
const BillDetail = () => import('@/pages/FwBusiness/Customer/BillDetail.vue')
const RecordDetail = () => import('@/pages/FwBusiness/Customer/RecordDetail.vue')
const ContractDetail = () => import('@/pages/FwBusiness/Customer/ContractDetail.vue')
const AddTryProduct = () => import('@/pages/FwBusiness/Customer/AddTryProduct.vue')
const Authentication = () => import('@/pages/FwBusiness/Customer/Authentication.vue')
const Advisory = () => import('@/pages/FwBusiness/Customer/Advisory.vue')
const ChurnRecord = () => import('@/pages/FwBusiness/Customer/ChurnRecord.vue')

/** Product */
const ProductList = () => import('@/pages/FwBusiness/Product/List.vue')
const ProductCategory = () => import('@/pages/FwBusiness/Product/Category.vue')
const ProductInterfaceList = () => import('@/pages/FwBusiness/Product/Interface.vue')
const ProductDetail = () => import('@/pages/FwBusiness/Product/Detail.vue')
const ProductServiceConfig = () => import('@/pages/FwBusiness/Product/serviceConfig.vue')
/** 电竞产品 */
const ElectronicSportsInterfaceList = () => import('@/pages/FwBusiness/Product/ElectronicSports/Interface.vue')
const ElectronicProductList = () => import('@/pages/FwBusiness/Product/ElectronicSports/List.vue')

// 电竞数据面板
const ElectronicSportDataManagement = () => import('@/pages/FwBusiness/ElectronicDataPanel/DataManagement/Index.vue')
const ElectronicSportOperatingRecord = () => import('@/pages/FwBusiness/ElectronicDataPanel/OperatingRecord/List.vue')
const ElectornicSportInterfaceDetail = () => import('@/pages/FwBusiness/ElectronicDataPanel/DataManagement/InterfaceDetail.vue')
const ElectronicSportDataAbnormalManagement = () => import('@/pages/FwBusiness/ElectronicDataPanel/DataAbnormalManagement/List.vue')
const ElectronicSportMappingKey = () => import('@/pages/FwBusiness/ElectronicDataPanel/MappingKey/List.vue')
const ElectronicSportMappingNameEdit = () => import('@/pages/FwBusiness/ElectronicDataPanel/MappingKey/MappingEdit/MappingNameEdit.vue')
const ElectronicSportMappingIdEdit = () => import('@/pages/FwBusiness/ElectronicDataPanel/MappingKey/MappingEdit/MappingIdEdit.vue')
const ElectronicSportDataAbnormalDetail = () => import('@/pages/FwBusiness/ElectronicDataPanel/DataAbnormalManagement/DataAbnormalDetail.vue')
const ElectornicSportDataSourceMessage = () => import('@/pages/FwBusiness/ElectronicDataPanel/DataSourceMessage/List.vue')
const ElectornicSportLiveSourceManagement = () => import('@/pages/FwBusiness/ElectronicDataPanel/LiveSourceManagement/Live.vue')
const ElectornicSportLiveDetail = () => import('@/pages/FwBusiness/ElectronicDataPanel/LiveSourceManagement/LiveList/LiveDetail.vue')
const ElectornicSportAddLive = () => import('@/pages/FwBusiness/ElectronicDataPanel/LiveSourceManagement/LiveList/AddLive.vue')
const ElectornicSportAddLiveSource = () => import('@/pages/FwBusiness/ElectronicDataPanel/LiveSourceManagement/LiveSource/EditLiveSource.vue')
const ElectornicSportAddLivePullSourceDetail = () => import('@/pages/FwBusiness/ElectronicDataPanel/LiveSourceManagement/LiveSource/livePullSourceDetail.vue')
/** FwBusiness End */

/** Finance */
const FinanceIncomeDetail = () => import('@/pages/Finance/IncomeDetail.vue')
const FinanceIncomeStatistic = () => import('@/pages/Finance/IncomeStatistic.vue')
const FinanceRenewalManagement = () => import('@/pages/Finance/RenewalManagement.vue')
const InvoiceData = () => import('@/pages/Finance/BillInfoManagement.vue')
const InvoiceManagement = () => import('@/pages/Finance/InvoiceManagement.vue')
/** Finance End */

/** Lottery */
// const LotteryCustomerList = () => import('@/pages/Lottery/Customer/List.vue')
// const LotteryCustomerDetail = () => import('@/pages/Lottery/Customer/Detail.vue')
// const LotteryCustomerRecordDetail = () => import('@/pages/Lottery/Customer/RecordDetail.vue')
// const LotteryCustomerContactDetail = () => import('@/pages/Lottery/Customer/ContactDetail.vue')
// const LotteryBillDetail = () => import('@/pages/Lottery/Customer/BillDetail.vue')
// const LotteryInformation = () => import('@/pages/Lottery/Customer/Information.vue')

// const LotteryTransactionRecord = () => import('@/pages/Lottery/TransactionRecord.vue')

// const LotteryInterfaceList = () => import('@/pages/Lottery/Interface/List.vue')
// const LotteryInterfaceDataFlow = () => import('@/pages/Lottery/Interface/DataFlow.vue')
// const LotteryInterfaceReEdit = () => import('@/pages/Lottery/Interface/ReEdit.vue')
// const LotteryInterfaceGroup = () => import('@/pages/Lottery/Interface/InterfaceGroup.vue')
/** Lottery End */

export const constantRouterMap = [
  {
    name: 'index',
    path: '/',
    redirect: '/fw-business/electronic-sport-data-panel/data-management',
    title: '首页',
    hidden: true
  },
  {
    name: 'login',
    path: '/login',
    title: '登录',
    component: Login,
    hidden: true
  }
]

export const asyncRouterMap = [
  {
    name: 'common',
    title: '通用管理',
    path: '/common',
    component: Layout,
    hidden: true, // 电竞版本隐藏
    children: [
      {
        name: 'common-user',
        path: '/common/user',
        title: '用户管理',
        component: SubLayout,
        children: [
          {
            path: 'analysis',
            name: 'Useranalysis',
            title: '用户分析',
            component: UserAnalysis
          },
          {
            path: 'list',
            name: 'UserList',
            title: '用户列表',
            component: UserList,
            meta: {
              roles: [AdminRole.EDITOR, AdminRole.ADMIN_SUPER, AdminRole.TECHNICAL]
            }
          },
          {
            name: 'ipRecord',
            path: 'ipRecord',
            component: CustomerIpRecord,
            title: '历史IP',
            meta: {
              roles: [AdminRole.EDITOR, AdminRole.ADMIN_SUPER, AdminRole.TECHNICAL]
            }
          },
          {
            path: 'detail/:userId',
            name: 'UserDetail',
            title: '用户详情',
            component: UserDetail,
            props: true,
            hidden: true,
            meta: {
              roles: [AdminRole.EDITOR, AdminRole.ADMIN_SUPER, AdminRole.TECHNICAL]
            }
          }
        ]
      },
      {
        name: 'common-analysis',
        path: 'analysis',
        title: '流量统计',
        component: CommonAnalysis,
        meta: {
          roles: [AdminRole.EDITOR, AdminRole.ADMIN_SUPER, AdminRole.TECHNICAL]
        }
      },
      {
        name: 'common-web',
        path: '/common/web',
        title: '网站管理',
        component: SubLayout,
        children: [
          {
            name: 'linkList',
            path: 'list',
            title: '友链列表',
            component: commonPage.LinkList
          },
          {
            name: 'linkClick',
            path: 'click/:linkId',
            title: '友链点击',
            component: commonPage.LinkClick,
            hidden: true
          },
          {
            name: 'businessCaseList',
            path: 'CaseList',
            title: '案例列表',
            component: commonPage.BusinessCaseList,
            meta: {
              roles: [AdminRole.EDITOR, AdminRole.ADMIN_SUPER, AdminRole.TECHNICAL]
            }
          },
          {
            name: 'businessCaseEdit',
            path: 'CaseEdit/:businessCaseId',
            title: '编辑案例',
            component: commonPage.BusinessCaseEdit,
            hidden: true,
            meta: {
              roles: [AdminRole.EDITOR, AdminRole.ADMIN_SUPER, AdminRole.TECHNICAL]
            }
          }
        ]
      },
      {
        name: 'common-notice',
        path: 'notice',
        title: '失败通知',
        component: CommonNotice,
        meta: {
          roles: [AdminRole.EDITOR, AdminRole.ADMIN_SUPER, AdminRole.TECHNICAL]
        }
      }
    ]
  },
  {
    name: 'fw-business',
    path: '/fw-business',
    component: Layout,
    title: '飞鲸数据',
    hidden: true, // 电竞版本隐藏
    meta: {
      roles: [AdminRole.EDITOR, AdminRole.ADMIN_SUPER, AdminRole.TECHNICAL]
    },
    children: [
      {
        name: 'customer-management',
        path: '/fw-business/customer',
        component: SubLayout,
        title: '客户管理',
        children: [
          {
            path: 'authList',
            name: 'auth-list',
            title: '企业认证',
            component: Authentication,
            meta: {
              roles: [AdminRole.EDITOR, AdminRole.ADMIN_SUPER, AdminRole.TECHNICAL]
            }
          },
          {
            path: 'advisoryList',
            name: 'advisory-list',
            title: '咨询报价',
            component: Advisory,
            meta: {
              roles: [AdminRole.EDITOR, AdminRole.ADMIN_SUPER, AdminRole.TECHNICAL]
            }
          },
          {
            path: 'business-list',
            name: 'business-list',
            title: '购买意愿',
            component: CustomerBusinessList,
            meta: {
              roles: [AdminRole.EDITOR, AdminRole.ADMIN_SUPER, AdminRole.TECHNICAL]
            }
          },
          {
            name: 'service-provision',
            path: 'service-provision',
            component: ServiceProvisionList,
            title: '开通服务',
            meta: {
              roles: [AdminRole.EDITOR, AdminRole.ADMIN_SUPER, AdminRole.TECHNICAL]
            }
          },
          {
            name: 'customer-list',
            path: 'list',
            title: '客户列表',
            component: CustomerList,
            meta: {
              roles: [AdminRole.EDITOR, AdminRole.ADMIN_SUPER, AdminRole.TECHNICAL]
            }
          },
          {
            name: 'churn-record-list',
            path: 'churn-record-list',
            title: '流失记录',
            component: ChurnRecord,
            meta: {
              roles: [AdminRole.EDITOR, AdminRole.ADMIN_SUPER, AdminRole.TECHNICAL]
            }
          },
          {
            name: 'customer-information',
            path: 'information/:id',
            title: '编辑客户信息',
            hidden: true,
            component: CustomerInformation,
            meta: {
              roles: [AdminRole.EDITOR, AdminRole.ADMIN_SUPER, AdminRole.TECHNICAL]
            }
          },
          {
            name: 'customer-detail',
            path: 'detail/:userId',
            title: '客户详情',
            hidden: true,
            component: CustomerDetail,
            props: true,
            meta: {
              roles: [AdminRole.EDITOR, AdminRole.ADMIN_SUPER, AdminRole.TECHNICAL]
            }
          },
          {
            name: 'contact-add',
            path: 'contact/add/:userId',
            title: '添加联系人',
            hidden: true,
            component: ContactDetail,
            meta: {
              roles: [AdminRole.EDITOR, AdminRole.ADMIN_SUPER, AdminRole.TECHNICAL]
            }
          },
          {
            name: 'contact-edit',
            path: 'contact/:userId/:id',
            title: '编辑联系人',
            hidden: true,
            component: ContactDetail,
            meta: {
              isEdit: true,
              roles: [AdminRole.EDITOR, AdminRole.ADMIN_SUPER, AdminRole.TECHNICAL]
            }
          },
          {
            name: 'bill-detail',
            path: 'bill/:userId/:id',
            title: '编辑开票信息',
            hidden: true,
            component: BillDetail,
            meta: {
              roles: [AdminRole.EDITOR, AdminRole.ADMIN_SUPER, AdminRole.TECHNICAL]
            }
          },
          {
            name: 'record-add',
            path: 'record/add/:userId',
            title: '添加回访记录',
            hidden: true,
            component: RecordDetail,
            meta: {
              roles: [AdminRole.EDITOR, AdminRole.ADMIN_SUPER, AdminRole.TECHNICAL]
            }
          },
          {
            name: 'record-edit',
            path: 'record/:userId/:id',
            title: '编辑回访记录',
            hidden: true,
            component: RecordDetail,
            meta: {
              isEdit: true,
              roles: [AdminRole.EDITOR, AdminRole.ADMIN_SUPER, AdminRole.TECHNICAL]
            }
          },
          {
            name: 'contract-add',
            path: 'contract/add/:userId',
            title: '添加合同',
            hidden: true,
            component: ContractDetail,
            meta: {
              roles: [AdminRole.EDITOR, AdminRole.ADMIN_SUPER, AdminRole.TECHNICAL]
            }
          },
          {
            name: 'contract-edit',
            path: 'contract/:userId/:id',
            title: '编辑合同',
            hidden: true,
            component: ContractDetail,
            meta: {
              isEdit: true,
              roles: [AdminRole.EDITOR, AdminRole.ADMIN_SUPER, AdminRole.TECHNICAL]
            }
          },
          {
            path: 'addTry/:userId/:serviceType?',
            name: 'AddTryProduct',
            title: '添加试用产品',
            component: AddTryProduct,
            hidden: true,
            meta: {
              roles: [AdminRole.EDITOR, AdminRole.ADMIN_SUPER, AdminRole.TECHNICAL]
            }
          }
        ]
      },
      {
        name: 'product-management',
        path: '/fw-business/product',
        component: SubLayout,
        title: '体育产品管理',
        children: [
          {
            name: 'fw-product-list',
            path: 'list',
            title: '产品列表',
            component: ProductList,
            meta: {
              roles: [AdminRole.EDITOR, AdminRole.ADMIN_SUPER, AdminRole.TECHNICAL]
            }
          },
          {
            name: 'product-detail',
            path: 'detail/:productId/:serviceType?',
            title: '产品详情',
            component: ProductDetail,
            hidden: true,
            meta: {
              roles: [AdminRole.EDITOR, AdminRole.ADMIN_SUPER, AdminRole.TECHNICAL]
            }
          },
          {
            path: 'add/:id/:serviceType?',
            name: 'AddProduct',
            title: '添加产品',
            component: UserAddProduct,
            hidden: true,
            props: true,
            meta: {
              roles: [AdminRole.EDITOR, AdminRole.ADMIN_SUPER, AdminRole.TECHNICAL]
            }
          },
          {
            name: 'category',
            path: 'category',
            title: '产品分类',
            component: ProductCategory,
            meta: {
              roles: [AdminRole.EDITOR, AdminRole.ADMIN_SUPER, AdminRole.TECHNICAL]
            }
          },
          {
            name: 'interface-list',
            path: 'interface',
            title: '接口文档',
            component: ProductInterfaceList,
            meta: {
              serviceType: 0,
              roles: [AdminRole.EDITOR, AdminRole.ADMIN_SUPER, AdminRole.TECHNICAL]
            }
          },
          {
            name: 'service-config',
            path: 'service-config',
            title: '服务配置',
            component: ProductServiceConfig,
            meta: {
              serviceType: 0,
              roles: [AdminRole.EDITOR, AdminRole.ADMIN_SUPER, AdminRole.TECHNICAL]
            }
          }
        ]
      },
      {
        name: 'electronic-sport-products',
        path: '/fw-business/electronic-sport-product',
        component: SubLayout,
        title: '电竞产品管理',
        children: [
          {
            name: 'electronic-interface-list',
            path: 'interface',
            title: '接口文档',
            component: ElectronicSportsInterfaceList,
            meta: {
              serviceType: 1,
              roles: [AdminRole.EDITOR, AdminRole.ADMIN_SUPER, AdminRole.TECHNICAL]
            }
          },
          {
            name: 'electronic-product-list',
            path: 'list',
            title: '产品列表',
            component: ElectronicProductList,
            meta: {
              serviceType: 1,
              roles: [AdminRole.EDITOR, AdminRole.ADMIN_SUPER, AdminRole.TECHNICAL]
            }
          },
          {
            name: 'electronic-service-config',
            path: 'service-config',
            title: '服务配置',
            component: ProductServiceConfig,
            meta: {
              serviceType: 1,
              roles: [AdminRole.EDITOR, AdminRole.ADMIN_SUPER, AdminRole.TECHNICAL]
            }
          }
        ]
      }
    ]
  },
  {
    name: 'electronic-sport-data-panel',
    path: '/fw-business/electronic-sport-data-panel',
    title: '电竞数据面板',
    component: Layout,
    children: [
      {
        name: 'electronic-sport-data-management',
        path: 'data-management',
        title: '数据管理',
        component: ElectronicSportDataManagement,
        meta: {
          roles: [AdminRole.EDITOR, AdminRole.ADMIN_SUPER, AdminRole.TECHNICAL]
        }
      },
      {
        name: 'electronic-sport-match-score',
        path: 'interface-detail/:id/:gameType/:pageType',
        title: '赛事比分',
        hidden: true,
        component: ElectornicSportInterfaceDetail,
        meta: {
          roles: [AdminRole.EDITOR, AdminRole.ADMIN_SUPER, AdminRole.TECHNICAL]
        }
      },
      {
        name: 'electronic-sport-battle-detail',
        path: 'interface-detail/:id/:gameType/:pageType/:isLive',
        title: '小局统计',
        hidden: true,
        component: ElectornicSportInterfaceDetail,
        meta: {
          roles: [AdminRole.EDITOR, AdminRole.ADMIN_SUPER, AdminRole.TECHNICAL]
        }
      },
      {
        name: 'electronic-sport-bet-detail',
        path: 'interface-detail/:id/:gameType/:pageType',
        title: '赔率信息',
        hidden: true,
        component: ElectornicSportInterfaceDetail,
        meta: {
          roles: [AdminRole.EDITOR, AdminRole.ADMIN_SUPER, AdminRole.TECHNICAL]
        }
      },
      {
        name: 'electronic-sport-operating-record',
        path: 'operating-record',
        title: '数据校正',
        component: ElectronicSportOperatingRecord,
        meta: {
          roles: [AdminRole.EDITOR, AdminRole.ADMIN_SUPER, AdminRole.TECHNICAL]
        }
      },
      {
        name: 'electronic-sport-data-abnormal-management',
        path: 'data-abnormal-management',
        title: '数据异常任务',
        component: ElectronicSportDataAbnormalManagement,
        meta: {
          roles: [AdminRole.EDITOR, AdminRole.ADMIN_SUPER, AdminRole.TECHNICAL]
        }
      },
      {
        name: 'MappingKeyList',
        path: 'MappingKeyList',
        title: '数据匹配规则',
        component: ElectronicSportMappingKey,
        meta: {
          roles: [AdminRole.EDITOR, AdminRole.ADMIN_SUPER, AdminRole.TECHNICAL]
        }
      },
      {
        name: 'mappingNameEdit',
        path: 'mappingNameEdit/:id',
        title: '新增名称匹配规则',
        component: ElectronicSportMappingNameEdit,
        hidden: true,
        props: true,
        meta: {
          roles: [AdminRole.EDITOR, AdminRole.ADMIN_SUPER, AdminRole.TECHNICAL]
        }
      },
      {
        name: 'mappingIdEdit',
        path: 'mappingIdEdit/:id',
        title: '新增ID匹配规则',
        component: ElectronicSportMappingIdEdit,
        hidden: true,
        props: true,
        meta: {
          roles: [AdminRole.EDITOR, AdminRole.ADMIN_SUPER, AdminRole.TECHNICAL]
        }
      },
      {
        name: 'electronic-sport-data-abnormal-detail',
        path: 'data-abnormal-detail/:recordId',
        title: '数据异常信息',
        hidden: true,
        component: ElectronicSportDataAbnormalDetail,
        meta: {
          roles: [AdminRole.EDITOR, AdminRole.ADMIN_SUPER, AdminRole.TECHNICAL]
        }
      },
      {
        name: 'electronic-sport-data-source-message',
        path: 'data-source-message',
        title: '数据源管理',
        component: ElectornicSportDataSourceMessage,
        meta: {
          roles: [AdminRole.EDITOR, AdminRole.ADMIN_SUPER, AdminRole.TECHNICAL]
        }
      },
      {
        name: 'electronic-sport-live-source-management',
        path: 'live-source-management',
        title: '直播源管理',
        component: ElectornicSportLiveSourceManagement,
        meta: {
          roles: [AdminRole.EDITOR, AdminRole.ADMIN_SUPER, AdminRole.TECHNICAL]
        }
      },
      {
        name: 'live-detail',
        path: 'detail/:id',
        title: '直播详情',
        component: ElectornicSportLiveDetail,
        meta: {
          roles: [AdminRole.EDITOR, AdminRole.ADMIN_SUPER, AdminRole.TECHNICAL]
        },
        hidden: true
      },
      {
        name: 'add-live',
        path: 'addLive',
        title: '添加直播',
        component: ElectornicSportAddLive,
        meta: {
          roles: [AdminRole.EDITOR, AdminRole.ADMIN_SUPER, AdminRole.TECHNICAL]
        },
        hidden: true
      },
      {
        name: 'add-live-source',
        path: 'addLiveSource/:id',
        title: '添加直播源',
        component: ElectornicSportAddLiveSource,
        meta: {
          roles: [AdminRole.EDITOR, AdminRole.ADMIN_SUPER, AdminRole.TECHNICAL]
        },
        hidden: true
      },
      {
        name: 'live-pull-source-detail',
        path: 'live-pull-source-detail/:recordId',
        title: '直播流其他信息',
        hidden: true,
        component: ElectornicSportAddLivePullSourceDetail,
        meta: {
          roles: [AdminRole.EDITOR, AdminRole.ADMIN_SUPER, AdminRole.TECHNICAL]
        }
      }
    ]
  },
  // {
  //   name: 'partner',
  //   path: '/partner',
  //   title: '合作方',
  //   hidden: true,
  //   component: Layout,
  //   children: [
  //     {
  //       name: 'partnerList',
  //       path: 'list',
  //       title: '合作方列表',
  //       component: commonPage.PartnerList
  //     },
  //     {
  //       name: 'partnerTypeList',
  //       path: 'type/list',
  //       title: '合作方分类',
  //       component: commonPage.PartnerTypeList
  //     }
  //   ]
  // },
  {
    name: 'finance-manangement',
    path: '/finance',
    component: Layout,
    title: '财务管理',
    hidden: true, // 电竞版本隐藏
    children: [
      {
        name: 'bill-info-management',
        path: 'invoice/data',
        title: '开票资料',
        component: InvoiceData,
        meta: {
          roles: [AdminRole.EDITOR, AdminRole.ADMIN_SUPER, AdminRole.TECHNICAL]
        }
      },
      {
        name: 'invoice-management',
        path: 'invoice/management',
        title: '发票任务',
        component: InvoiceManagement,
        meta: {
          roles: [AdminRole.EDITOR, AdminRole.ADMIN_SUPER, AdminRole.TECHNICAL]
        }
      },
      {
        name: 'customer-renewal-management',
        path: 'renewal/management',
        title: '续费管理',
        component: FinanceRenewalManagement,
        meta: {
          roles: [AdminRole.EDITOR, AdminRole.ADMIN_SUPER, AdminRole.TECHNICAL]
        }
      },
      {
        name: 'customer-income-detail',
        path: 'income/detail',
        title: '收入明细',
        component: FinanceIncomeDetail,
        meta: {
          roles: [AdminRole.EDITOR, AdminRole.ADMIN_SUPER, AdminRole.TECHNICAL]
        }
      },
      {
        name: 'customer-income-statistic',
        path: 'income/statistic',
        title: '收入统计',
        component: FinanceIncomeStatistic,
        meta: {
          roles: [AdminRole.EDITOR, AdminRole.ADMIN_SUPER, AdminRole.TECHNICAL]
        }
      }
    ]
  },
  // {
  //   name: 'lottyer',
  //   path: '/lottery',
  //   title: '缤果数据',
  //   component: Layout,
  //   children: [
  //     {
  //       name: 'lottery-customer',
  //       path: '/lottery/customer',
  //       title: '客户管理',
  //       component: SubLayout,
  //       children: [
  //         {
  //           name: 'lottery-customer-list',
  //           path: 'list',
  //           title: '客户列表',
  //           component: LotteryCustomerList,
  //           meta: {
  //             roles: [AdminRole.EDITOR, AdminRole.ADMIN_SUPER, AdminRole.TECHNICAL]
  //           }
  //         },
  //         {
  //           name: 'lottery-record-edit',
  //           path: 'editRecord/:userId/:id',
  //           title: '编辑回访记录',
  //           hidden: true,
  //           component: LotteryCustomerRecordDetail,
  //           meta: {
  //             isEdit: true,
  //             roles: [AdminRole.EDITOR, AdminRole.ADMIN_SUPER, AdminRole.TECHNICAL]
  //           }
  //         },
  //         {
  //           name: 'lottery-record-add',
  //           path: 'addRecord/:userId',
  //           title: '编辑回访记录',
  //           hidden: true,
  //           component: LotteryCustomerRecordDetail,
  //           meta: {
  //             roles: [AdminRole.EDITOR, AdminRole.ADMIN_SUPER, AdminRole.TECHNICAL]
  //           }
  //         },
  //         {
  //           name: 'lottery-contact-add',
  //           path: 'contact/add/:userId',
  //           title: '添加联系人',
  //           hidden: true,
  //           component: LotteryCustomerContactDetail,
  //           meta: {
  //             roles: [AdminRole.EDITOR, AdminRole.ADMIN_SUPER, AdminRole.TECHNICAL]
  //           }
  //         },
  //         {
  //           name: 'lottery-contact-edit',
  //           path: 'contact/:userId/:id',
  //           title: '编辑联系人',
  //           hidden: true,
  //           component: LotteryCustomerContactDetail,
  //           meta: {
  //             isEdit: true,
  //             roles: [AdminRole.EDITOR, AdminRole.ADMIN_SUPER, AdminRole.TECHNICAL]
  //           }
  //         },
  //         {
  //           name: 'lottery-bill-detail',
  //           path: 'bill/:userId/:id',
  //           title: '编辑开票信息',
  //           hidden: true,
  //           component: LotteryBillDetail,
  //           meta: {
  //             roles: [AdminRole.EDITOR, AdminRole.ADMIN_SUPER, AdminRole.TECHNICAL]
  //           }
  //         },
  //         {
  //           name: 'lottery-customer-detail',
  //           path: 'detail/:id',
  //           title: '客户信息',
  //           hidden: true,
  //           props: true,
  //           component: LotteryCustomerDetail,
  //           meta: {
  //             roles: [AdminRole.EDITOR, AdminRole.ADMIN_SUPER, AdminRole.TECHNICAL]
  //           }
  //         },
  //         {
  //           name: 'lottery-customer-information',
  //           path: 'information/:id',
  //           title: '编辑客户信息',
  //           hidden: true,
  //           component: LotteryInformation,
  //           meta: {
  //             roles: [AdminRole.EDITOR, AdminRole.ADMIN_SUPER, AdminRole.TECHNICAL]
  //           }
  //         }
  //       ]
  //     },
  //     {
  //       name: 'lottery-financial-list',
  //       path: 'financialList',
  //       title: '交易记录',
  //       component: LotteryTransactionRecord,
  //       meta: {
  //         roles: [AdminRole.EDITOR, AdminRole.ADMIN_SUPER, AdminRole.TECHNICAL]
  //       }
  //     },
  //     {
  //       name: 'lottery-product',
  //       path: '/lottery/product',
  //       title: '产品管理',
  //       component: SubLayout,
  //       meta: {
  //         roles: [AdminRole.EDITOR, AdminRole.ADMIN_SUPER, AdminRole.TECHNICAL]
  //       },
  //       children: [
  //         {
  //           name: 'lottery-product-list',
  //           path: 'list',
  //           title: '接口列表',
  //           component: LotteryInterfaceList,
  //           meta: {
  //             roles: [AdminRole.EDITOR, AdminRole.ADMIN_SUPER, AdminRole.TECHNICAL]
  //           }
  //         },
  //         {
  //           name: 'lottery-data-flow-list',
  //           path: 'dataflow',
  //           title: '流量统计',
  //           component: LotteryInterfaceDataFlow,
  //           meta: {
  //             roles: [AdminRole.EDITOR, AdminRole.ADMIN_SUPER, AdminRole.TECHNICAL]
  //           }
  //         },
  //         {
  //           name: 'lottery-group-list',
  //           path: 'group',
  //           title: '接口分类',
  //           component: LotteryInterfaceGroup,
  //           meta: {
  //             roles: [AdminRole.EDITOR, AdminRole.ADMIN_SUPER, AdminRole.TECHNICAL]
  //           }
  //         },
  //         {
  //           name: 'lottery-edit-product',
  //           path: 'add',
  //           hidden: true,
  //           title: '编辑接口',
  //           component: LotteryInterfaceReEdit,
  //           meta: {
  //             roles: [AdminRole.EDITOR, AdminRole.ADMIN_SUPER, AdminRole.TECHNICAL]
  //           }
  //         },
  //         {
  //           name: 'lottery-add-product',
  //           path: 'add',
  //           title: '添加接口',
  //           hidden: true,
  //           component: LotteryInterfaceReEdit,
  //           meta: {
  //             roles: [AdminRole.EDITOR, AdminRole.ADMIN_SUPER, AdminRole.TECHNICAL]
  //           }
  //         }
  //       ]
  //     }
  //   ]
  // },
  {
    name: 'article',
    path: '/article/management',
    title: '文章管理',
    component: Layout,
    hidden: true, // 电竞版本隐藏
    children: [
      {
        name: 'articleList',
        path: 'list',
        title: '文章列表',
        component: commonPage.ArticleList
      },
      {
        name: 'articleEdit',
        path: 'edit/:articleId',
        title: '编辑文章',
        hidden: true,
        component: commonPage.ArticleEdit
      },
      {
        name: 'articleTypeList',
        path: 'type/list',
        title: '分类管理',
        component: commonPage.ArticleTypeList
      },
      {
        name: 'articleSourceList',
        path: 'source/list',
        title: '来源管理',
        component: commonPage.ArticleSourceList
      }
    ]
  },
  // {
  //   name: 'ad',
  //   path: '/ad/management',
  //   title: '广告管理',
  //   component: Layout,
  //   hidden: true,
  //   children: [
  //     {
  //       name: 'siteList',
  //       path: 'site/list',
  //       title: '站点',
  //       component: commonPage.AdSiteList
  //     },
  //     {
  //       name: 'siteEdit',
  //       path: 'site/edit/:siteId',
  //       title: '编辑站点',
  //       hidden: true,
  //       component: commonPage.AdSiteEdit
  //     },
  //     {
  //       name: 'inventoryList',
  //       path: 'inventory/list',
  //       title: '广告位',
  //       component: commonPage.AdInventoryList
  //     },
  //     {
  //       name: 'inventoryEdit',
  //       path: 'inventory/edit/:inventoryId',
  //       title: '编辑广告位',
  //       hidden: true,
  //       component: commonPage.AdInventoryEdit
  //     },
  //     {
  //       name: 'adContentList',
  //       path: 'adContent/list',
  //       title: '广告内容',
  //       component: commonPage.AdContentList
  //     },
  //     {
  //       name: 'adContentEdit',
  //       path: 'adContent/edit/:contentId',
  //       title: '编辑广告内容',
  //       hidden: true,
  //       component: commonPage.AdContentEdit
  //     },
  //     {
  //       name: 'adCampaignList',
  //       path: 'campaign/list',
  //       title: '投放广告',
  //       component: commonPage.AdCampaignList
  //     },
  //     {
  //       name: 'adCampaignAdd',
  //       path: 'campaign/add',
  //       title: '编辑投放广告内容',
  //       hidden: true,
  //       component: commonPage.AdCampaignAdd
  //     },
  //     {
  //       name: 'adCampaignStatsList',
  //       path: 'campaign/stats/list',
  //       title: '投放统计',
  //       component: commonPage.AdCampaignStatsList
  //     },
  //     {
  //       name: 'AdCampaignDetail',
  //       path: 'campaign/detail/:campaignId',
  //       title: '投放统计详情',
  //       hidden: true,
  //       component: commonPage.AdCampaignDetail
  //     }
  //   ]
  // },
  {
    name: 'dataDictionary',
    path: '/dataDictionary/management',
    title: '数据字典管理',
    component: Layout,
    hidden: true,
    children: [
      {
        name: 'dataDictionaryList',
        path: 'list',
        title: '字段列表',
        component: commonPage.DataDictionaryList
      },
      {
        name: 'dataDictionaryEdit',
        path: 'edit/:dictionaryId',
        title: '编辑字段',
        hidden: true,
        component: commonPage.DataDictionaryEdit
      }
    ]
  },
  {
    name: 'module',
    path: '/module/management',
    title: '模块管理',
    component: Layout,
    hidden: true,
    children: [
      {
        name: 'moduleList',
        path: 'list',
        title: '模块列表',
        component: commonPage.ModuleList
      },
      {
        name: 'moduleEdit',
        path: 'edit/:moduleId',
        title: '模块编辑',
        hidden: true,
        component: commonPage.ModuleEdit
      }
    ]
  },
  {
    name: 'admin',
    path: '/admin/management',
    title: '系统管理',
    component: Layout,
    children: [
      {
        name: 'adminModifyPassword',
        path: 'password',
        title: '修改密码',
        component: commonPage.AdminModifyPassword,
        hidden: true
      },
      {
        name: 'adminList',
        path: 'admin/list',
        title: '管理员列表',
        component: commonPage.AdminList
      },
      {
        name: 'adminRoleList',
        path: 'role/list',
        title: '角色权限管理',
        hidden: true, // 电竞版本隐藏
        component: commonPage.AdminRoleList
      },
      {
        name: 'adminRoleEdit',
        path: 'role/edit/:roleId',
        title: '编辑管理员权限',
        component: commonPage.AdminEditRole,
        hidden: true
      },
      {
        name: 'adminRoleAdd',
        path: 'role/add',
        title: '添加管理员权限',
        component: commonPage.AdminEditRole,
        hidden: true
      },
      {
        name: 'log',
        path: 'log',
        title: '操作日志',
        component: commonPage.AdminLog
      },
      {
        name: 'system-params',
        path: 'system-params',
        title: '在线参数',
        component: commonPage.ParamList
      }
    ]
  }
]



// WEBPACK FOOTER //
// ./src/routes.js